/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module UpdateModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { ITSEGroup } from 'ajs/modules/service-engine-group/factories/se-group.item.factory';
import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services/schema-service/schema.service';
import { AviDatePipe } from 'ng/modules/core/pipes';
import { UpgradePrechecksErrorStatusTypeHash } from '../../../update.types';
import './seg-update-grid-expander.less';
import * as l10n from './seg-update-grid-expander.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

const preCheckStateSet = new Set(
    Object.values(UpgradePrechecksErrorStatusTypeHash),
);

/**
 * @description Component for SEG Update page Grid Expander.
 * @author Sarthak Kapoor
 */
@Component({
    selector: 'seg-update-grid-expander',
    templateUrl: './seg-update-grid-expander.component.html',
})
export class SegUpdateGridExpanderComponent implements OnInit {
    @Input()
    public seGroup: ITSEGroup;

    public haModeLabel: string;

    /**
     * Timestamp when the latest operatin on node ended.
     */
    public updatedOn: string;

    public readonly l10nKeys = l10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly schemaService: SchemaService,
        private readonly aviDatePipe: AviDatePipe,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.setHaModeLabel();
        this.setUpdatedOn();
    }

    private setHaModeLabel(): void {
        const { haMode } = this.seGroup;

        this.haModeLabel = haMode ? this.schemaService.getEnumValue('HaMode', haMode).label : '-';
    }

    private setUpdatedOn(): void {
        const { upgradeReadiness = {} } = this.seGroup;
        const { state = {} } = upgradeReadiness;

        this.updatedOn = preCheckStateSet.has(state.state) ?
            this.aviDatePipe.transform(`${upgradeReadiness.end_time}+00:00`) :
            this.aviDatePipe.transform(this.seGroup.upgradeEndTime) || '-';
    }
}
